import { css } from '@emotion/react';

import { zIndex } from 'shared/config';
import COLORS from 'shared/styles/colors';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  '&.submission-form-buttons': {
    position: 'fixed',
    bottom: 0,
    justifyContent: 'center',
    padding: ` ${theme.space[4]}`,
    zIndex: zIndex.zStickyElements,
    textAlign: 'center',
    display: 'flex',
    gap: '10px',
    backgroundColor: COLORS.NEUTRAL50,
    left: 0,
    right: 0,
    [mediaquery.md]: {
      position: 'relative',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 0,
      gap: 0,
      backgroundColor: COLORS.WHITE,
    },
  },
  '.submission-form-buttons': {
    '&__button': {
      whiteSpace: 'nowrap',
      [mediaquery.md]: {
        whiteSpace: 'nowrap',
        marginLeft: theme.space[3],
      },
    },
    '&__submit-button': {
      whiteSpace: 'nowrap',
      flex: '1 0 0',
      [mediaquery.md]: {
        whiteSpace: 'nowrap',
        marginLeft: theme.space[3],
      },
    },
  },
});
